import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';

export default class NewsletterComponent extends Component {
  get COMPONENTNAME() {
    return 'NewsletterComponent';
  }

  get SELECTORS() {
    return {
      formWrapper: '[data-form-wrapper]',
      form: '[data-form]',
      submitCta: '[data-submit-cta]',
      privacyCheckbox: '.js-privacy-cta', // due to jsp limits
      emailInput: '[data-js-component="InputComponent"]',
    }
  }

  get CSS() {
    return {
      loading: '--loading',
      success: '--success',
    }
  }

  readDOM() {
    return {
      formWrapper: this.$component.querySelector(this.SELECTORS.formWrapper),
      form: this.$component.querySelector(this.SELECTORS.form),
      submitCta: this.$component.querySelector(this.SELECTORS.submitCta),
      privacyCheckbox: this.$component.querySelector(this.SELECTORS.privacyCheckbox),
      emailInput: this.$component.querySelector(this.SELECTORS.emailInput),
    }
  }

  render() {
    this.dom = this.readDOM();
    this.renderSubmitBtn();
    this.bindEvents();
  }

  renderSubmitBtn() {
    if(this.dom.emailInput.component) {
      this.dom.submitCta.disabled = (this.dom.emailInput.component.value.length === 0 || !this.dom.privacyCheckbox.checked);
    }
  }

  bindEvents() {
    this.dom.privacyCheckbox.addEventListener('change', () => { this.renderSubmitBtn() });
    this.dom.emailInput.addEventListener('change', () => { this.renderSubmitBtn() });

    this.dom.form.addEventListener('submit', evt => {
      evt.preventDefault();
      this.handleFormSubmit(evt);
    })

    // TODO
    // this.$on('submit.newsletter', this.NewsletterLogic.subscribeToNewsletter, this.SELECTORS.newsletterBox, this.SELECTORS.form, this);
  }

  subscribeToNewsletter() {
    const url = this.dom.form.getAttribute('action');
    const params = (new URLSearchParams(new FormData(this.dom.form))).toString();

    return fetch(url, {
      method: 'POST',
      body: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(res => res.text())
      .then(rbody => {
        const rdoc = (new DOMParser()).parseFromString(rbody, 'text/html');

        const error = rdoc.querySelector('span.error');
        if (error) throw new Error(error.innerText);

        const formError = rdoc.querySelector('div.nl-form__messages__msg.--error');
        if (formError) throw new Error(formError.innerText);

        return rdoc;
      });
  }

  handleFormSubmit(evt) {
    this.dom.formWrapper.classList.add(this.CSS.loading);
    this.subscribeToNewsletter()
      .then(() => {
        this.$component.classList.add(this.CSS.success);
        const trackingComponent = new TrackingComponent();
        trackingComponent.trackAction('newsletterSubscribe', this.dom.submitCta.dataset , this.dom.submitCta);
        this.emit(this.$customEvents.NEWSLETTER.subscribed);
      })
      .catch(err => {
        this.dom.emailInput.component.setError(err.message);
      })
      .finally(() => {
        this.dom.formWrapper.classList.remove(this.CSS.loading);
      })
  }
}
